import { intl } from "LocaleWrapper";
import { Typography } from "@mui/material";
import {
	TimelineItem,
	TimelineSeparator,
	TimelineConnector,
	TimelineContent,
	TimelineOppositeContent,
	TimelineDot,
} from "@mui/lab";
import { FormattedCalendarDate, FormattedDate } from "utils/DateUtils";
import { AnglerEvents, getInitialTagSettings, VoyagePlanLockEvent } from "../../AnglerUtils";

const AnglerTimelineLockEvent = ({ event }: { event: VoyagePlanLockEvent }) => {
	return (
		<TimelineItem>
			<TimelineOppositeContent sx={{ m: "auto 0" }}>
				<Typography variant="h6" color="textPrimary" sx={{ fontSize: 12 }}>
					<FormattedCalendarDate date={event.startTime} />
				</Typography>
			</TimelineOppositeContent>

			<TimelineSeparator>
				<TimelineConnector />
				<TimelineDot sx={{ backgroundColor: getInitialTagSettings()[AnglerEvents.Lock].color }}>
					{getInitialTagSettings()[AnglerEvents.Lock].icon}
				</TimelineDot>
				<TimelineConnector />
			</TimelineSeparator>

			<TimelineContent sx={{ m: "auto 0" }}>
				<AnglerTimelineLockEventInformation event={event} />
			</TimelineContent>
		</TimelineItem>
	);
};

export const AnglerTimelineLockEventInformation = ({ event }: { event: VoyagePlanLockEvent }) => (
	<>
		<Typography variant="h6" color="textPrimary" sx={{ fontSize: 12 }}>
			{event.name}
		</Typography>

		<Typography variant="h6" color="textSecondary" sx={{ fontSize: 11 }}>
			<FormattedDate date={event.lastUpdate} withoutYear />

			{event.status && (
				<>
					{" • "}
					{intl.formatMessage({ id: `ANGLER_LOCK_${event.status}` })}
				</>
			)}
		</Typography>
	</>
);

export default AnglerTimelineLockEvent;
